module.exports = __webpack_public_path__ + "static/img/2025年历-5.81aaae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2025年历-5.png
// module id = 74XK
// module chunks = 3